var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJourneyCompletionCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.78049 0.83733 6.79048C0.00476617 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3165 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9966 8.08367 20.8365 5.28778 18.7744 3.22563C16.7122 1.16347 13.9163 0.00344047 11 0ZM15.707 9.207L10.707 14.207C10.5195 14.3945 10.2652 14.4998 10 14.4998C9.73484 14.4998 9.48053 14.3945 9.293 14.207L6.293 11.207C6.19749 11.1148 6.12131 11.0044 6.0689 10.8824C6.01649 10.7604 5.98891 10.6292 5.98775 10.4964C5.9866 10.3636 6.0119 10.2319 6.06218 10.109C6.11246 9.98615 6.18672 9.8745 6.28061 9.7806C6.3745 9.68671 6.48615 9.61246 6.60905 9.56218C6.73195 9.5119 6.86363 9.48659 6.9964 9.48775C7.12918 9.4889 7.2604 9.51649 7.38241 9.5689C7.50441 9.62131 7.61476 9.69749 7.707 9.793L10 12.086L14.293 7.793C14.4816 7.61084 14.7342 7.51005 14.9964 7.51232C15.2586 7.5146 15.5094 7.61977 15.6948 7.80518C15.8802 7.99059 15.9854 8.2414 15.9877 8.5036C15.99 8.76579 15.8892 9.0184 15.707 9.207Z",
    fill: "url(#paint0_linear_398_10028)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_10028",
    x1: -2.27999,
    y1: 25.729,
    x2: 18.382,
    y2: 2.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BF99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyCompletionCheck);
export default __webpack_public_path__ + "static/media/JourneyCompletionCheck.6be36cb38b910237009950821c21469b.svg";
export { ForwardRef as ReactComponent };